import { FlexWrapper, FontIcon, Text } from '@intigral/shared';
import { FlexChild } from '@intigral/shared/components/FlexWrapper';
import { SimpleDialog } from '@intigral/ui/components/SimpleDialog';
import { __ } from '../../../../translations';
import { InSufficientPointPopupProps } from '../../types/iGamification';

const InSufficientPointPopup = ({
    isOpen,
    handleCloseModal,
    currentPoint,
    requiredPoint,
    isInsufficientPopupType,
}: InSufficientPointPopupProps) => {
    const getDescriptionHtml = () => {
        const templateKey =
            isInsufficientPopupType === 'tier_upgrade'
                ? 'insufficient_point_popup_description'
                : 'insufficient_point_popup_description_tvod';

        return __(templateKey)
            .replace('{requiredPoint}', requiredPoint.toString())
            .replace('{currentPoint}', currentPoint.toString())
            .replaceAll('<b>', `<b style="color: var(--white-80);">`);
    };

    return (
        <SimpleDialog
            open={isOpen}
            lbClose={__('insufficient_point_popup_close')}
            onOpenChange={handleCloseModal}
            presetWidth="small"
        >
            <FlexWrapper flexDirection="column" gap={{ default: '2x', md: '2x' }} data-test-id="success-fail-modal">
                <FlexChild alignSelf="center" placement={'center'}>
                    <FontIcon name="exclamation-mark" size="large" md="large" />
                </FlexChild>

                <FlexChild alignSelf="center" placement={'center'}>
                    <Text as="h3" variant="h5" alignment="center" margin="2x">
                        {__('insufficient_point_popup_title')}
                    </Text>
                </FlexChild>

                <FlexChild alignSelf="center" placement={'center'}>
                    <Text
                        as="p"
                        variant="text2"
                        alignment="center"
                        margin="2x"
                        dangerouslySetInnerHTML={{ __html: getDescriptionHtml() }}
                    />
                </FlexChild>
            </FlexWrapper>
        </SimpleDialog>
    );
};

export default InSufficientPointPopup;
